// @ts-nocheck

import React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';
import Formatter from '../../../../i18n/formatter';
import { __, getCurrency } from '../../../../i18n/l10n';
import type { GridMatchLength } from '../../types';
import PoolTitle from '../pool/PoolTitle';

const Nav = styled.nav`
  overflow: hidden;
  ${({ theme }) => theme.grids.desktopBloc}
`;

const Ul = styled.ul``;

const Li = styled.li`
  line-height: 1.4;

  &:active {
    transform: scale(0.95);
  }
`;

const commonLinkTitle = css`
  display: block;
  border-radius: 0.4em;

  padding: 1em;
  margin: 1em;
  text-align: center;
  font-size: 0.9em;

  ${({ $isFocus, theme }) => css`
    background: ${$isFocus ? '#fff' : theme.grids.gradients.black()};
    color: ${theme.grids.colors.middlegrey3};

    ${Target.__MOBILE__
      ? undefined
      : css`
          &:hover {
            color: ${theme.grids.colors.middlegrey3};
          }
          &:hover .poolTitle,
          &:hover .gridDate {
            color: ${theme.grids.colors.black};
          }
        `}

    .gridDate {
      color: ${$isFocus ? theme.grids.colors.black : '#fff'};
    }
  `}
`;

const Title = styled.p`
  color: #fff;
  margin: 1em;
  text-transform: uppercase;
  font-family: BettingPoliticaBold, sans-serif;
  text-align: center;
  letter-spacing: 0.1em;
  font-size: 0.9em;
`;

const StyledLink = styled(Link)`
  ${commonLinkTitle}
  ${Target.__MOBILE__
    ? undefined
    : css`
        &:hover {
          background: #fff;
        }
      `}

  &:focus {
    outline: 0;
  }
`;

const P = styled.p`
  font-size: 1em;
`;

const Line = styled.p`
  width: 25px;
  height: 1px;
  background: ${({ theme }) => theme.grids.colors.middlegrey2};
  margin: 0.2em auto;
`;

const StyledPoolTitle = styled(PoolTitle)`
  color: ${({ $isFocus, theme }) => ($isFocus ? theme.grids.colors.black : '#fff')};
`;

type MenuItem = {
  poolId: number;
  poolNumber: number;
  link: string;
  guaranty: number;
  date: string;
  isFocus: boolean;
  gridReference?: string;
  date?: string;
  poolType: GridMatchLength;
};

type GridsMenuDesktopProps = {
  openPools: Array<MenuItem>;
};

const Item = ({ poolNumber, link, gridReference, guaranty, isFocus, date, poolType }) => (
  <Li>
    <StyledLink to={link} $isFocus={isFocus}>
      <StyledPoolTitle $isFocus={isFocus} poolNumber={poolNumber} className="poolTitle" poolType={poolType} />
      {guaranty && <P>{__('%1$s guarenteed ', Formatter.formatNumber(guaranty, getCurrency(), false, true))}</P>}
      {gridReference && <P>{gridReference}</P>}
      {date && (
        <>
          <Line />
          <P className="gridDate">{date}</P>
        </>
      )}
    </StyledLink>
  </Li>
);

const GridsMenuDesktop = ({ openPools }: GridsMenuDesktopProps) => {
  return (
    <Nav>
      <Title>{openPools.length !== 1 ? __('Next grids') : __('Next grid')}</Title>
      {openPools.length > 0 ? (
        <Ul>
          {openPools.map(({ poolNumber, link, gridReference, guaranty, isFocus, date, poolType }) => (
            <Item
              key={link}
              poolNumber={poolNumber}
              link={link}
              gridReference={gridReference}
              guaranty={guaranty}
              isFocus={isFocus}
              date={date}
              poolType={poolType}
            />
          ))}
        </Ul>
      ) : null}
    </Nav>
  );
};

export default GridsMenuDesktop;
